/*
 * @Author: 许炎
 * @FilePath: /mall-fe/sentry.config.js
 * @Description: sentry系统接入域名配置文件
 *
 */

const dsns = {
  local: 'https://137e90075187f563c996ca1f9e7dc778@sentry-st.3jyx.cn/71',
  zjdev: 'https://137e90075187f563c996ca1f9e7dc778@sentry-st.3jyx.cn/71',
  zjst: 'https://137e90075187f563c996ca1f9e7dc778@sentry-st.3jyx.cn/71',
  zjpre: 'https://2604c115ac1bfdc958ec555c17ab29de@sentry-ga.3jyx.cn/93',
  zjga: 'https://2604c115ac1bfdc958ec555c17ab29de@sentry-ga.3jyx.cn/93',
};

const hosts = {
  local: 'https://sentry-st.3jyx.cn',
  zjdev: 'https://sentry-st.3jyx.cn',
  zjst: 'https://sentry-st.3jyx.cn',
  zjpre: 'https://sentry-ga.3jyx.cn',
  zjga: 'https://sentry-ga.3jyx.cn',
};

module.exports = {
  dsns,
  hosts,
};
